// extracted by mini-css-extract-plugin
export default {"button":"button-ChjHkvVj","icon":"icon-MdQBgS7f"};